import { Help } from '@plasma/ui.application.app';

const help: Help[] = [
  // {
  //   title: 'ZoneMaster',
  //   description: 'description of ZoneMaster',
  //   url: '/zone-master',
  // },
];

export default help;
